import { useEffect, useMemo } from "react";
import { Navigate, useOutletContext, useParams } from "react-router-dom";
import MenuView from "@/components/menu/MenuView";

export default function MenuPage() {
  const { data, mode, base } = useOutletContext();
  const { slug } = useParams();
  const menu = data.menus?.find((m) => m.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  const scoped = useMemo(() => {
    if (!menu) return null;
    const cats = data.categories.filter((c) => c.menu_id === menu.id);
    const ids = new Set(cats.map((c) => c.id));
    const first = data.menus[0]?.id === menu.id;
    const h = data.settings.hero;
    const hero = menu.image_url
      ? { ...h, image_url: menu.image_url, headline_en: menu.name_en, headline_ar: menu.name_ar, subtitle_en: menu.description_en, subtitle_ar: menu.description_ar, promo_en: "", promo_ar: "" }
      : { ...h, enabled: h.enabled && first };
    return { ...data, settings: { ...data.settings, hero }, categories: cats, items: data.items.filter((i) => ids.has(i.category_id)) };
  }, [data, menu]);

  if (!menu) return <Navigate to={base || "/"} replace />;
  return <MenuView key={menu.id} data={scoped} mode={mode} menu={menu} backHref={base || "/"} />;
}
